import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { authAPI } from '../services/api';
import toast from 'react-hot-toast';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [merchant, setMerchant] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      authAPI.getMe()
        .then(({ data }) => {
          setUser(data.data.user);
          setMerchant(data.data.merchant);
        })
        .catch(() => {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await authAPI.login({ email, password });
    localStorage.setItem('token', data.data.accessToken);
    setUser(data.data.user);
    setMerchant(data.data.merchant);
    return data.data;
  }, []);

  const register = useCallback(async (formData) => {
    const { data } = await authAPI.register(formData);
    localStorage.setItem('token', data.data.accessToken);
    setUser(data.data.user);
    setMerchant(data.data.merchant);
    return data.data;
  }, []);

  const logout = useCallback(async () => {
    try { await authAPI.logout(); } catch (_) {}
    localStorage.removeItem('token');
    setUser(null);
    setMerchant(null);
    toast.success('Logged out');
  }, []);

  const updateMerchant = useCallback((updates) => {
    setMerchant(prev => ({ ...prev, ...updates }));
  }, []);

  const isSuperAdmin = user?.role === 'super_admin';
  const isMerchant = user?.role === 'merchant';
  const isAgent = user?.role === 'agent';

  return (
    <AuthContext.Provider value={{ user, merchant, loading, login, register, logout, updateMerchant, isSuperAdmin, isMerchant, isAgent }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};
